import { createContext, useContext, useEffect, useState } from "react";
import { useProducts } from "@/shop/ProductsContext";
import { track } from "@/lib/pixel";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const { getProduct } = useProducts();
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("zentra-cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("zentra-cart", JSON.stringify(items));
  }, [items]);

  const add = (slug, qty = 1) => {
    const p = getProduct(slug);
    if (!p || p.in_stock === false) return;
    setItems((prev) => {
      const found = prev.find((i) => i.slug === slug);
      if (found) return prev.map((i) => (i.slug === slug ? { ...i, qty: i.qty + qty } : i));
      return [...prev, { slug, qty }];
    });
    setOpen(true);
    track("AddToCart", {
      content_ids: [p.sku],
      content_type: "product",
      value: p.price * qty,
      currency: "INR",
      contents: [{ id: p.sku, quantity: qty, item_price: p.price }],
    });
  };

  const setQty = (slug, qty) => {
    if (qty <= 0) return removeItem(slug);
    setItems((prev) => prev.map((i) => (i.slug === slug ? { ...i, qty } : i)));
  };

  const removeItem = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const clear = () => setItems([]);

  const detailed = items
    .map((i) => ({ ...i, product: getProduct(i.slug) }))
    .filter((i) => i.product);
  const count = detailed.reduce((a, i) => a + i.qty, 0);
  const subtotal = detailed.reduce((a, i) => a + i.product.price * i.qty, 0);

  return (
    <CartContext.Provider
      value={{ items: detailed, add, setQty, removeItem, clear, count, subtotal, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};
